import Model        from "../core/Model";

const SQMT         = 'sqmt';
const SQFT         = 'sqft';


const SQMT_TO_SQFT = 10.7639104;
const SQFT_TO_SQMT = 0.09290304;

export default class Area extends Model
{
    constructor( options = {} )
    {
        super(null);

        this.setOptions(options);
    }

    setOptions( options = {} )
    {
        this.value     = options.value  || 0;
        this.unit      = options.unit   || SQMT;
    }

    toJson ()
    {
        return {
            unit   : this.unit,
            value  : this.value,
        }
    }

    label(){

        return printf('%s %s', this.value, Area.symbolHtml(this.unit))
    }

    sqmt(){

        return this.unit === SQMT ? this.value : Math.round(this.value * SQMT_TO_SQFT);
    }

    sqft (){
        return this.unit === SQFT ? this.value : Math.round(this.value * SQFT_TO_SQMT);
    }

    static symbolHtml(unit){

        switch (unit) {

            case SQMT: return 'm<sup>2</sup>'; break;
            case SQFT: return 'ft<sup>2</sup>'; break;
        }

        return null;
    }

    static symbol(unit){

        switch (unit) {

            case SQMT: return 'm2';  break;
            case SQFT: return 'ft2'; break;
        }

        return null;
    }




}


// WEBPACK FOOTER //
// ./resources/js/models/Area.js